import xhrController from './core';

let options = {
    gtm: true,
    cache: true,
    duration: {
        in: 600,
        out: 600,
        auto: false,
        className: '.anim-fade, .anim-slide, .anim-slide-left, .anim-slide-right'
        //className: '.anim-fade, .detail__circle'
    },
    specialPages: [
        {
            url: '/',
            class: 'to-hp'
        },
        {
            url: '/cs/',
            class: 'to-hp'
        }
    ],
    specialElements: [
        '#langs'
    ]
}

let xhrcontroller = null;

if (document.documentElement.className.indexOf('cms') === -1) {
    let xhrcontroller = new xhrController(options)
    // for debbuging
    window.xhrcontroller = xhrcontroller
}

//export options
export default xhrcontroller




// WEBPACK FOOTER //
// ./core/xhrController/index.js